import Protected from './ProtectedContainer'

export default Protected



// WEBPACK FOOTER //
// ./src/components/Protected/index.js